// extracted by mini-css-extract-plugin
module.exports = {"section":"k_1p6ax","inner":"k_hq03y","wrap":"k_qqihh","faqList":"k_3inlu","circle":"k_WEmbE","header":"k_1iVgk","description":"k_3LSOi","active":"k_D4Umu"};